import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _56e14da1 = () => interopDefault(import('../../../pages/au/index.vue' /* webpackChunkName: "pages/au/index" */))
const _0faef30f = () => interopDefault(import('../../../pages/blog/index.vue' /* webpackChunkName: "pages/blog/index" */))
const _7732bd6a = () => interopDefault(import('../../../pages/ca/index.vue' /* webpackChunkName: "pages/ca/index" */))
const _2e3e9ab3 = () => interopDefault(import('../../../pages/checkout/index.vue' /* webpackChunkName: "pages/checkout/index" */))
const _bfa94fd6 = () => interopDefault(import('../../../pages/cookies.vue' /* webpackChunkName: "pages/cookies" */))
const _8768067e = () => interopDefault(import('../../../pages/courses/index.vue' /* webpackChunkName: "pages/courses/index" */))
const _06389409 = () => interopDefault(import('../../../pages/efl-teacher/index.vue' /* webpackChunkName: "pages/efl-teacher/index" */))
const _9cc4536a = () => interopDefault(import('../../../pages/en-us/index.vue' /* webpackChunkName: "pages/en-us/index" */))
const _46234c89 = () => interopDefault(import('../../../pages/ie/index.vue' /* webpackChunkName: "pages/ie/index" */))
const _01743079 = () => interopDefault(import('../../../pages/my-account/index.vue' /* webpackChunkName: "pages/my-account/index" */))
const _755c7cd4 = () => interopDefault(import('../../../pages/za/index.vue' /* webpackChunkName: "pages/za/index" */))
const _870ad1ca = () => interopDefault(import('../../../pages/cart/basket.vue' /* webpackChunkName: "pages/cart/basket" */))
const _6a08dd7d = () => interopDefault(import('../../../pages/checkout/balance.vue' /* webpackChunkName: "pages/checkout/balance" */))
const _1c79d835 = () => interopDefault(import('../../../pages/checkout/manual.vue' /* webpackChunkName: "pages/checkout/manual" */))
const _c8f3f098 = () => interopDefault(import('../../../pages/en-us/courses/index.vue' /* webpackChunkName: "pages/en-us/courses/index" */))
const _24f45ca6 = () => interopDefault(import('../../../pages/en-us/my-account/index.vue' /* webpackChunkName: "pages/en-us/my-account/index" */))
const _baf4bc8a = () => interopDefault(import('../../../pages/my-account/dashboard.vue' /* webpackChunkName: "pages/my-account/dashboard" */))
const _7489ef68 = () => interopDefault(import('../../../pages/en-us/my-account/dashboard.vue' /* webpackChunkName: "pages/en-us/my-account/dashboard" */))
const _77c4443f = () => interopDefault(import('../../../pages/tefl-jobs-centre/cv-builder/my-cv.vue' /* webpackChunkName: "pages/tefl-jobs-centre/cv-builder/my-cv" */))
const _bcb55576 = () => interopDefault(import('../../../pages/tefl-jobs-centre/cv-builder/new-cv.vue' /* webpackChunkName: "pages/tefl-jobs-centre/cv-builder/new-cv" */))
const _126e7a9f = () => interopDefault(import('../../../pages/blog/category/_category.vue' /* webpackChunkName: "pages/blog/category/_category" */))
const _04cf890d = () => interopDefault(import('../../../pages/blog/page/_id.vue' /* webpackChunkName: "pages/blog/page/_id" */))
const _58149ea2 = () => interopDefault(import('../../../pages/tefl-jobs-centre/job/_slug.vue' /* webpackChunkName: "pages/tefl-jobs-centre/job/_slug" */))
const _7838fc0a = () => interopDefault(import('../../../pages/blog/category/_subcategory/_category.vue' /* webpackChunkName: "pages/blog/category/_subcategory/_category" */))
const _0df851c7 = () => interopDefault(import('../../../pages/blog/_slug.vue' /* webpackChunkName: "pages/blog/_slug" */))
const _48428c12 = () => interopDefault(import('../../../pages/resume/_slug.vue' /* webpackChunkName: "pages/resume/_slug" */))
const _0547af50 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _b186cf36 = () => interopDefault(import('../../../pages/_.vue' /* webpackChunkName: "pages/_" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/au",
    component: _56e14da1,
    name: "au"
  }, {
    path: "/blog",
    component: _0faef30f,
    name: "blog"
  }, {
    path: "/ca",
    component: _7732bd6a,
    name: "ca"
  }, {
    path: "/checkout",
    component: _2e3e9ab3,
    name: "checkout"
  }, {
    path: "/cookies",
    component: _bfa94fd6,
    name: "cookies"
  }, {
    path: "/courses",
    component: _8768067e,
    name: "courses"
  }, {
    path: "/efl-teacher",
    component: _06389409,
    name: "efl-teacher"
  }, {
    path: "/en-us",
    component: _9cc4536a,
    name: "en-us"
  }, {
    path: "/ie",
    component: _46234c89,
    name: "ie"
  }, {
    path: "/my-account",
    component: _01743079,
    name: "my-account"
  }, {
    path: "/za",
    component: _755c7cd4,
    name: "za"
  }, {
    path: "/cart/basket",
    component: _870ad1ca,
    name: "cart-basket"
  }, {
    path: "/checkout/balance",
    component: _6a08dd7d,
    name: "checkout-balance"
  }, {
    path: "/checkout/manual",
    component: _1c79d835,
    name: "checkout-manual"
  }, {
    path: "/en-us/courses",
    component: _c8f3f098,
    name: "en-us-courses"
  }, {
    path: "/en-us/my-account",
    component: _24f45ca6,
    name: "en-us-my-account"
  }, {
    path: "/my-account/dashboard",
    component: _baf4bc8a,
    name: "my-account-dashboard"
  }, {
    path: "/en-us/my-account/dashboard",
    component: _7489ef68,
    name: "en-us-my-account-dashboard"
  }, {
    path: "/tefl-jobs-centre/cv-builder/my-cv",
    component: _77c4443f,
    name: "tefl-jobs-centre-cv-builder-my-cv"
  }, {
    path: "/tefl-jobs-centre/cv-builder/new-cv",
    component: _bcb55576,
    name: "tefl-jobs-centre-cv-builder-new-cv"
  }, {
    path: "/blog/category/:category?",
    component: _126e7a9f,
    name: "blog-category-category"
  }, {
    path: "/blog/page/:id?",
    component: _04cf890d,
    name: "blog-page-id"
  }, {
    path: "/tefl-jobs-centre/job/:slug?",
    component: _58149ea2,
    name: "tefl-jobs-centre-job-slug"
  }, {
    path: "/blog/category/:subcategory?/:category?",
    component: _7838fc0a,
    name: "blog-category-subcategory-category"
  }, {
    path: "/blog/:slug",
    component: _0df851c7,
    name: "blog-slug"
  }, {
    path: "/resume/:slug?",
    component: _48428c12,
    name: "resume-slug"
  }, {
    path: "/",
    component: _0547af50,
    name: "index"
  }, {
    path: "/*",
    component: _b186cf36,
    name: "all"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
